/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import Modal from "react-bootstrap/Modal";
import { Trans } from "react-i18next";
import "components/widgets/training/Training.css";
import i18next from "i18next";

class RolePlayDetail extends Component {

  state = {
    showingTabletDetail: false,
    showingRolePlayDetails: [],
    modalShow: false,
    modalContent: "",
    modalTitle: ""
  };

  toggleTabletDetail = (idx) => {
    let showing = this.state.showingTabletDetail;
    this.setState({ showingTabletDetail: !showing });
    this.togglePersonnels(idx);
  };

  togglePersonnels = (idx) => {
    let showingRolePlayDetails = [...this.state.showingRolePlayDetails];
    showingRolePlayDetails[idx] = !showingRolePlayDetails[idx];
    showingRolePlayDetails.forEach((sp, i) => {
      if (i !== idx) showingRolePlayDetails[i] = false;
    });
    this.setState({ showingRolePlayDetails });
  };

  openModal = (content, title) => {
    this.setState({ modalShow: true, modalContent: content, modalTitle: title })
  }

  closeModal = () => {
    this.setState({ modalShow: false, modalContent: "", modalTitle: "" })
  }

  renderModal = () => {
    return (
      <Modal show={this.state.modalShow} onHide={() => this.closeModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>{this.state.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.state.modalContent}</Modal.Body>
      </Modal>
    )
  }

  renderQuestionAndAnswers = () => {
    if (!this.props.rp.employeeRolePlayDetails) return null;

    return this.props.rp.employeeRolePlayDetails.map((p, index) => {
      return (
        <tr key={index} className="grupEgitim spanHide" onClick={() => this.openModal(p.description, p.question)}>
          <td></td>
          <td>{p.question}</td>
          <td className="text-center">{p.answer}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      );
    });
  };

  renderNote = (title, content) => {
    return (
      <tr className="grupEgitim spanHide" onClick={() => this.openModal(content, title)}>
        <td></td>
        <td className="text-center">
          <b>{title}</b>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    );
  };

  renderTabletModeDetail = (t) => {
    if (!this.state.showingTabletDetail) return null;

    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr>
                <td>
                  <div className="tableTitle">
                    <Trans desc="Durum">10727</Trans>
                  </div>
                </td>
                <td>{t.case}</td>
              </tr>
              <tr>
                <td>
                  <div className="tableTitle">
                    <Trans desc="Araç">10728</Trans>
                  </div>
                </td>
                <td>{t.vehicle}</td>
              </tr>
              <tr>
                <td>
                  <div className="tableTitle">
                    <Trans desc="Tarih">10729</Trans>
                  </div>
                </td>
                <td style={{ fontSize: '11px' }}>{new Date(t.date).toLocaleString(localStorage.getItem("i18nextLng"))}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { rp, idx } = this.props;
    return (
      <>
        <DesktopBreakpoint>
          <React.Fragment key={rp.id}>
            <tr key={rp.id} className="grupEgitim hasChild" onClick={() => this.togglePersonnels(idx)}>
              <td className="showGrup">{rp.session}</td>
              <td className="showGrup"></td>
              <td className="showGrup"></td>
              <td className="showGrup">{rp.case}</td>
              <td className="showGrup">{rp.vehicle}</td>
              <td className="showGrup">{new Date(rp.date).toLocaleString(localStorage.getItem("i18nextLng"))}</td>
              <td className="showGrup openCloseBtn">
                <span className="iconmford fo-icon-add"></span>
              </td>
            </tr>
          </React.Fragment>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr className={this.rowClassName} onClick={() => this.toggleTabletDetail(idx)}>
            <td className="showGrup">{rp.session}</td>
            <td className="showGrup openCloseBtn tbltOpener">
              <span className="iconmford fo-icon-add"></span>
            </td>
          </tr>
          {this.renderTabletModeDetail(rp)}
        </TabletBreakpoint>
        {this.state.showingRolePlayDetails[idx] ? (
          <tr className="child">
            <td className="child" colSpan="7">
              <table className="table">
                <tbody>
                  {this.renderQuestionAndAnswers()}
                  {localStorage.getItem("roles") == "Personnel" || this.props.userId == this.props.selectedEmployeeId ? this.renderNote(i18next.t("10751").toUpperCase(), this.props.rp.personnelNote) : null}
                  {localStorage.getItem("roles") == "Manager" && this.renderNote(i18next.t("10752").toUpperCase(), this.props.rp.managerNote)}
                </tbody>
              </table>
            </td>
          </tr>
        ) : null}
        {this.renderModal()}
      </>
    );
  }
}

export default RolePlayDetail;
